<h2 mat-dialog-title class="modal-add-header">
  <mat-icon class="with-text">person</mat-icon>แก้ไขข้อมูลส่วนบุคคล
</h2>
<form [formGroup]="fg" (ngSubmit)="updateAdmin()" #form>
  <mat-dialog-content>

    <mat-form-field>
      <mat-label>ชื่อผู้ดูแล</mat-label>
      <input matInput placeholder="ชื่อผู้ดูแล" formControlName="name">
      <mat-error *ngIf="fg.get('name').getError('required')">{{ e.changePasswordInputNewPassword }}</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>เบอร์โทรศัพท์</mat-label>
      <input matInput tplaceholder="เบอร์โทรศัพท์" formControlName="phoneNumber">
      <mat-error *ngIf="fg.get('phoneNumber').getError('required')">{{ e.changePasswordInputConfirmPassword }}</mat-error>
    </mat-form-field>
    <mat-divider></mat-divider>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-spacer"></div>
    <button type="button" mat-raised-button mat-dialog-close [mat-dialog-close]="true">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button type="button" mat-raised-button class="submit-button" (click)="updateAdmin()">บันทึก</button>
  </mat-dialog-actions>
</form>